
export default {
    name: 'TestError',
    props: {
        // 接受错误页面传递的错误信息
        error: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        console.log(this.error)
    },
}
